{
  "admission": "உள்நோயாளி சேர்க்கை",
  "transfer": "மாற்றம்",
  "visit": "சந்திப்பு",
  "type": "சந்திப்பு வகை",
  "status": "நிலை",
  "location": "இடம்",
  "attendingPhysician": "பொறுப்பு மருத்துவர்",
  "admitDate": "சேர்க்கப்பட்ட தேதி",
  "dischargeDate": "வீடு திரும்பிய தேதி",
  "chiefComplaint": "முதன்மை புகார்",
  "diagnosis": "நோய் கண்டறிதல்",
  "class": {
    "label": "வகை",
    "values": {
      "emergency": "அவசர சிகிச்சை",
      "inpatient": "உள்நோயாளி",
      "outpatient": "வெளிநோயாளி",
      "observation": "கண்காணிப்பு",
      "ambulatory": "நாள் பராமரிப்பு",
      "homeHealth": "வீட்டு மருத்துவம்",
      "virtual": "தொலைதூர மருத்துவம்"
    }
  },
  "statusValues": {
    "label": "நிலை",
    "values": {
      "pending": "நிலுவையில்",
      "arrived": "வந்துள்ளார்",
      "active": "செயலில்",
      "completed": "முடிக்கப்பட்டது",
      "cancelled": "ரத்து செய்யப்பட்டது"
    }
  },
  "admissionSource": {
    "label": "சேர்க்கை மூலம்",
    "none": "—",
    "values": {
      "emergency": "அவசர சிகிச்சை பிரிவு",
      "clinicReferral": "மருத்துவமனை பரிந்துரை",
      "physicianReferral": "மருத்துவர் பரிந்துரை",
      "transfer": "வேறு மருத்துவமனையிலிருந்து மாற்றம்",
      "self": "சுய வருகை / நடந்து வருதல்",
      "courtLaw": "நீதிமன்றம் / சட்ட அமலாக்கம்"
    }
  },
  "admissionType": {
    "label": "சேர்க்கை வகை",
    "none": "—",
    "values": {
      "elective": "திட்டமிடப்பட்ட",
      "emergency": "அவசர",
      "urgent": "அவசரம்",
      "newborn": "புதிதாகப் பிறந்தவர்",
      "trauma": "காயம்"
    }
  },
  "acuity": {
    "label": "தீவிர நிலை",
    "none": "—",
    "values": {
      "1": "1 — உயிர்ப்பித்தல்",
      "2": "2 — அவசரம்",
      "3": "3 — அவசர",
      "4": "4 — குறைந்த அவசர",
      "5": "5 — அவசரமற்ற"
    },
    "shortValues": {
      "1": "உயிர்ப்பித்தல்",
      "2": "அவசரம்",
      "3": "அவசர",
      "4": "குறைந்த அவசர",
      "5": "அவசரமற்ற"
    },
    "esiBadge": "ESI {{level}} - {{label}}"
  },
  "form": {
    "title": "புதிய சந்திப்பு",
    "subtitle": "இந்த நோயாளிக்கு புதிய சந்திப்பு / சேர்க்கையை தொடங்கவும்.",
    "sections": {
      "visit": "சந்திப்பு விவரங்கள்",
      "reasonForVisit": "சந்திப்பு காரணம்",
      "admission": "சேர்க்கை விவரங்கள்"
    },
    "fields": {
      "facility": "மருத்துவ நிலையம்",
      "encounterClass": "சந்திப்பு வகை",
      "encounterType": "சந்திப்பு வகை விரிவு",
      "department": "துறை",
      "attendingProvider": "பொறுப்பு மருத்துவர்",
      "acuity": "தீவிர நிலை",
      "visitReason": "சந்திப்பு காரணம்",
      "chiefComplaint": "முதன்மை புகார்",
      "admissionSource": "சேர்க்கை மூலம்",
      "admissionType": "சேர்க்கை வகை"
    },
    "placeholders": {
      "selectFacility": "மருத்துவ நிலையத்தைத் தேர்ந்தெடுக்கவும்",
      "none": "—",
      "encounterType": "எ.கா. ஆண்டு பரிசோதனை, ER வருகை",
      "visitReason": "சுருக்க முத்திரை, எ.கா. பின்தொடர்தல், ஆண்டு பரிசோதனை",
      "chiefComplaint": "நோயாளி தனது சொற்களில் கூறிய காரணம்"
    },
    "providerFallback": "மருத்துவர் #{{id}}",
    "submit": "சந்திப்பை உருவாக்கு",
    "validation": {
      "facilityRequired": "மருத்துவ நிலையம் தேவை",
      "encounterClassRequired": "சந்திப்பு வகை தேவை"
    },
    "createdSuccess": "சந்திப்பு உருவாக்கப்பட்டது",
    "createError": "சந்திப்பை உருவாக்க இயலவில்லை"
  },
  "detail": {
    "loading": "சந்திப்பு ஏற்றப்படுகிறது...",
    "notFound": "சந்திப்பு கிடைக்கவில்லை",
    "loadError": "சந்திப்பை ஏற்ற முடியவில்லை",
    "retry": "மீண்டும் முயல்க",
    "returnToDashboard": "டாஷ்போர்டுக்குத் திரும்பு",
    "header": {
      "title": "சந்திப்பு {{number}}",
      "facilityLabel": "மருத்துவ நிலையம் #{{id}}",
      "departmentLabel": "துறை #{{id}}",
      "locationLabel": "இடம் #{{id}}",
      "admittedLabel": "சேர்க்கப்பட்டது: {{datetime}}"
    },
    "actions": {
      "transfer": "மாற்றம்",
      "discharge": "வீடு திரும்புதல்"
    },
    "tabs": {
      "overview": "சுருக்கம்",
      "orders": "ஆணைகள்",
      "results": "முடிவுகள்",
      "medications": "மருந்துகள்",
      "notes": "குறிப்புகள்",
      "billing": "கட்டணம்"
    },
    "overview": {
      "chiefComplaint": "முதன்மை புகார்",
      "visitReason": "சந்திப்பு காரணம்",
      "attendingProvider": "பொறுப்பு மருத்துவர்",
      "acuityLevel": "தீவிர நிலை",
      "providerFallback": "மருத்துவர் #{{id}}",
      "empty": "--"
    },
    "timeline": {
      "title": "நிகழ்வுகள் காலவரிசை",
      "empty": "நிகழ்வுகள் எதுவும் பதிவாகவில்லை",
      "admittedTitle": "சேர்க்கப்பட்டது",
      "admittedDescription": "{{class}} - {{chiefComplaint}}",
      "noChiefComplaint": "முதன்மை புகார் இல்லை",
      "orderTitle": "ஆணை: {{name}}",
      "orderDescription": "{{type}} - {{priority}} - {{status}}",
      "resultTitle": "முடிவு: {{type}}"
    },
    "orders": {
      "title": "ஆணைகள்",
      "newOrder": "+ புதிய ஆணை",
      "empty": "இந்த சந்திப்புக்கு ஆணைகள் எதுவும் இல்லை",
      "metaLine": "{{number}} | {{type}} | முன்னுரிமை: {{priority}}"
    },
    "results": {
      "title": "முடிவுகள்",
      "empty": "இந்த சந்திப்புக்கு முடிவுகள் எதுவும் இல்லை",
      "criticalBadge": "தீவிரம்",
      "viewLink": "காண்க",
      "metaLine": "{{number}} | {{status}}"
    },
    "medications": {
      "title": "மருந்துகள்",
      "newMedication": "+ புதிய மருந்து",
      "empty": "இந்த சந்திப்புக்கு மருந்துகள் இல்லை",
      "prnBadge": "PRN",
      "prnWithIndication": "PRN: {{indication}}"
    },
    "notes": {
      "comingSoon": "மருத்துவ குறிப்புகள் தொகுதி விரைவில் வரும்",
      "goToClinicalNotes": "மருத்துவ குறிப்புகளுக்குச் செல்லவும்"
    },
    "billing": {
      "comingSoon": "கட்டண தொகுதி விரைவில் வரும்"
    }
  },
  "census": {
    "title": "படுக்கை பலகை / நோயாளி பட்டியல்",
    "subtitle": "நிகழ்நேர படுக்கை பயன்பாடு மற்றும் நோயாளி பட்டியல்",
    "refresh": "புதுப்பி",
    "facilityName": "சிங்கப்பூர் பொது மருத்துவமனை",
    "capacitySummary": "பயன்பாட்டில் {{occupied}} / மொத்தம் {{total}} படுக்கைகள்",
    "occupancyLabel": "பயன்பாடு {{percent}}%",
    "stats": {
      "totalCapacity": "மொத்த கொள்ளளவு",
      "occupied": "பயன்பாட்டில்",
      "available": "கிடைக்கின்றன",
      "pendingDischarge": "வீடு திரும்புதல் நிலுவையில்"
    },
    "unitFilter": {
      "all": "அனைத்து பிரிவுகள்",
      "er": "ER",
      "icu": "ICU",
      "medsurg": "மருத்துவம் / அறுவை சிகிச்சை",
      "obs": "கண்காணிப்பு",
      "peds": "குழந்தைகள் மருத்துவம்",
      "maternity": "பிரசவ பராமரிப்பு"
    },
    "roleView": {
      "nurse": "செவிலியர் காட்சி",
      "physician": "மருத்துவர் காட்சி",
      "bedManager": "படுக்கை மேலாளர் காட்சி"
    },
    "viewMode": {
      "grid": "கட்ட காட்சி",
      "table": "அட்டவணை காட்சி"
    },
    "loading": "நோயாளி பட்டியல் தரவு ஏற்றப்படுகிறது...",
    "columns": {
      "patient": "நோயாளி",
      "mrn": "MRN",
      "admitDate": "சேர்க்கப்பட்ட தேதி",
      "status": "நிலை",
      "acuity": "தீவிரம்",
      "isolation": "தனிமை",
      "fallRisk": "விழும் ஆபத்து",
      "codeStatus": "உயிர்காப்பு நிலை",
      "chiefComplaint": "முதன்மை புகார்",
      "attending": "பொறுப்பு",
      "los": "LOS",
      "locationBed": "இடம் / படுக்கை",
      "transferStatus": "மாற்ற நிலை",
      "expectedDischarge": "எதிர்பார்க்கப்படும் வெளியேற்றம்",
      "actions": "செயல்கள்"
    },
    "values": {
      "unknownPatient": "தெரியவில்லை",
      "none": "இல்லை",
      "notAvailable": "N/A",
      "pending": "நிலுவையில்",
      "empty": "--",
      "providerFallback": "மருத்துவர் #{{id}}",
      "locationLabel": "இடம் #{{id}}",
      "losDays": "{{days}} நாட்கள்"
    },
    "codeStatusTooltip": "உயிர்காப்பு நிலை நோயாளி அட்டையில் கிடைக்கும்",
    "actionsMenu": {
      "label": "செயல்கள்",
      "viewChart": "அட்டையைக் காண்க",
      "transfer": "மாற்றம்",
      "assignAttending": "பொறுப்பு மருத்துவரை நியமிக்கவும்",
      "discharge": "வீடு திரும்புதல்"
    },
    "empty": "செயலில் உள்ள சந்திப்புகள் எதுவும் இல்லை",
    "department": {
      "filteredTo": "{{name}} மட்டும் காட்டப்படுகிறது",
      "idLabel": "துறை {{id}}",
      "showAll": "அனைத்து துறைகளையும் காட்டு"
    },
    "facility": {
      "label": "வசதி",
      "allFacilities": "அனைத்து வசதிகள்",
      "idLabel": "வசதி {{id}}"
    }
  },
  "discharge": {
    "label": "வீடு திரும்புதல்",
    "title": "டிஸ்சார்ஜ் பணியோட்டம்",
    "encounterLabel": "சந்திப்பு {{number}}",
    "printButton": "டிஸ்சார்ஜ் அச்சிடு",
    "loading": "சந்திப்பை ஏற்றுகிறது...",
    "notFound": "சந்திப்பு கிடைக்கவில்லை",
    "returnToDashboard": "டாஷ்போர்டுக்குத் திரும்பு",
    "notActive": "இந்தச் சந்திப்பு செயலில் இல்லை (நிலை: {{status}})",
    "backToEncounter": "சந்திப்புக்குத் திரும்பு",
    "progress": {
      "requiredMissingTooltip": "கட்டாயப் புலங்கள் நிரப்பப்படவில்லை",
      "tasksRemainingTooltip": "சில பணிகள் நிலுவையில் உள்ளன"
    },
    "steps": {
      "summary": "டிஸ்சார்ஜ் சுருக்கம்",
      "medications": "மருந்துகள்",
      "followup": "தொடர் சந்திப்பு",
      "instructions": "வழிமுறைகள்",
      "nursing": "தாதியர் பணிகள்",
      "signoff": "கண்காணிப்பு மருத்துவர் ஒப்புதல்",
      "review": "மறுபரிசீலனை & உறுதிசெய்தல்"
    },
    "summary": {
      "title": "டிஸ்சார்ஜ் சுருக்கம்",
      "diagnosisLabel": "டிஸ்சார்ஜ் நோய் கண்டறிதல் *",
      "diagnosisPlaceholder": "டிஸ்சார்ஜ் நோய் கண்டறிதலை உள்ளிடவும்...",
      "diagnosisCodeLabel": "டிஸ்சார்ஜ் நோய் கண்டறிதல் குறியீடு (ICD-10)",
      "diagnosisCodePlaceholder": "ICD-10 குறியீட்டைத் தேடவும்...",
      "proceduresLabel": "செய்யப்பட்ட சிகிச்சை நடைமுறைகள்",
      "proceduresPlaceholder": "இந்தச் சந்திப்பில் செய்த நடைமுறைகளை பட்டியலிடவும்...",
      "conditionLabel": "டிஸ்சார்ஜ் நிலையில் நிலை *"
    },
    "condition": {
      "values": {
        "stable": "நிலையானது",
        "improved": "முன்னேற்றம்",
        "unchanged": "மாறவில்லை",
        "worsened": "மோசமானது",
        "critical": "தீவிரம்"
      }
    },
    "medications": {
      "title": "டிஸ்சார்ஜ் மருந்துகள்",
      "instructions": "ஒவ்வொரு மருந்தையும் மறுபரிசீலனை செய்து, தொடர், நிறுத்து அல்லது மாற்று என்று முடிவெடுக்கவும்.",
      "actions": {
        "continue": "தொடர்",
        "stop": "நிறுத்து",
        "modify": "மாற்று"
      },
      "modifiedPlaceholder": "மாற்றப்பட்ட வழிமுறைகளை உள்ளிடவும்...",
      "empty": "இந்தச் சந்திப்புக்கு செயலில் உள்ள மருந்துகள் இல்லை"
    },
    "medAction": {
      "values": {
        "continue": "தொடர்",
        "stop": "நிறுத்து",
        "modify": "மாற்று"
      }
    },
    "followup": {
      "title": "தொடர் சந்திப்பு திட்டம்",
      "providerLabel": "தொடர் சந்திப்பு மருத்துவர்",
      "providerPlaceholder": "மருத்துவர் பெயர் அல்லது சிறப்புத்துறை...",
      "dateLabel": "தொடர் சந்திப்பு தேதி",
      "notesLabel": "கூடுதல் குறிப்புகள்",
      "notesPlaceholder": "தொடர் சந்திப்புக்கான கூடுதல் குறிப்புகள்..."
    },
    "instructions": {
      "title": "நோயாளி வழிமுறைகள்",
      "generalLabel": "பொது வழிமுறைகள்",
      "generalPlaceholder": "நோயாளிக்கான பொது டிஸ்சார்ஜ் வழிமுறைகள்...",
      "dietaryLabel": "உணவு வழிமுறைகள்",
      "dietaryPlaceholder": "உணவு கட்டுப்பாடுகள் அல்லது பரிந்துரைகள்...",
      "activityLabel": "நடவடிக்கை கட்டுப்பாடுகள்",
      "activityPlaceholder": "உடல் நடவடிக்கை வரம்புகள்...",
      "warningSignsLabel": "கவனிக்க வேண்டிய எச்சரிக்கை அறிகுறிகள்",
      "warningSignsPlaceholder": "இந்த அறிகுறிகள் தோன்றினால் நோயாளி திரும்ப வர அல்லது சிகிச்சை பெற வேண்டும்..."
    },
    "nursing": {
      "title": "தாதியர் பணிகள்",
      "instructions": "டிஸ்சார்ஜ்க்கு முன் கீழ்க்கண்ட பட்டியலை முடிக்கவும். இவை பதிவுக்கு மட்டுமே; API அழைப்பு செய்யாது.",
      "tasks": {
        "removeIv": "IV அணுகலை அகற்று",
        "discontinueMonitoring": "கண்காணிப்பு உபகரணங்களை நிறுத்து",
        "patientEducation": "நோயாளி கல்வி முடிந்தது",
        "medsReviewed": "டிஸ்சார்ஜ் மருந்துகள் நோயாளியுடன் மறுபரிசீலனை செய்யப்பட்டன",
        "belongingsReturned": "தனிப்பட்ட பொருட்கள் திரும்ப அளிக்கப்பட்டன",
        "transportArranged": "போக்குவரத்து ஏற்பாடு செய்யப்பட்டது"
      }
    },
    "signoff": {
      "title": "கண்காணிப்பு மருத்துவர் ஒப்புதல்",
      "instructions": "கீழே உள்ள டிஸ்சார்ஜ் சுருக்கத்தை மறுபரிசீலனை செய்து, கண்காணிப்பு மருத்துவரின் ஒப்புதலைப் பெறவும்.",
      "diagnosisHeading": "டிஸ்சார்ஜ் நோய் கண்டறிதல்",
      "notProvided": "வழங்கப்படவில்லை",
      "medicationsHeading": "டிஸ்சார்ஜ் மருந்துகள்",
      "noMedications": "ஒத்திசைக்க மருந்துகள் இல்லை",
      "signedCompleted": "கண்காணிப்பு மருத்துவர் ஒப்புதல் முடிந்தது.",
      "signAsAttending": "கண்காணிப்பு மருத்துவராக ஒப்புதல் அளி",
      "requiresAttendingSignoff": "கண்காணிப்பு மருத்துவரின் ஒப்புதல் தேவை"
    },
    "review": {
      "title": "டிஸ்சார்ஜ் மறுபரிசீலனை & உறுதிசெய்தல்",
      "summaryHeading": "டிஸ்சார்ஜ் சுருக்கம்",
      "fields": {
        "diagnosis": "நோய் கண்டறிதல்:",
        "procedures": "நடைமுறைகள்:",
        "condition": "நிலை:",
        "provider": "மருத்துவர்:",
        "date": "தேதி:",
        "notes": "குறிப்புகள்:",
        "general": "பொது:",
        "diet": "உணவு:",
        "activity": "நடவடிக்கை:",
        "warningSigns": "எச்சரிக்கை அறிகுறிகள்:"
      },
      "medicationsHeading": "மருந்து ஒத்திசைவு",
      "noMedications": "ஒத்திசைக்க மருந்துகள் இல்லை",
      "followupHeading": "தொடர் சந்திப்பு",
      "instructionsHeading": "நோயாளி வழிமுறைகள்",
      "noInstructions": "வழிமுறைகள் ஏதும் வழங்கப்படவில்லை",
      "pendingOrdersWarning": "நிலுவையில் உள்ள ஆணைகள் அல்லது ஒப்புதல் பெறப்படாத குறிப்புகள் இருக்கலாம். டிஸ்சார்ஜை முடிக்க முன் சரிபார்க்கவும்.",
      "diagnosisRequired": "டிஸ்சார்ஜை முடிக்க முன் டிஸ்சார்ஜ் நோய் கண்டறிதல் தேவை.",
      "empty": "--"
    },
    "nav": {
      "previous": "முந்தைய",
      "next": "அடுத்தது",
      "complete": "டிஸ்சார்ஜ் முடிக்கவும்"
    },
    "toast": {
      "success": "நோயாளி வெற்றிகரமாக டிஸ்சார்ஜ் ஆனார்",
      "error": "டிஸ்சார்ஜ் முடிக்க முடியவில்லை"
    }
  },
  "components": {
    "transferDialog": {
      "title": "சந்திப்பை மாற்று",
      "description": "நோயாளியை இந்த நிறுவனத்தில் வேறு இடத்திற்கு மாற்றவும்.",
      "targetLocationLabel": "இலக்கு இடம்",
      "loadingLocations": "இடங்கள் ஏற்றப்படுகின்றன…",
      "selectLocation": "ஒரு இடத்தைத் தேர்ந்தெடுக்கவும்",
      "emptyState": "இந்த நிறுவனத்தில் வேறு செயலில் உள்ள இடங்கள் இல்லை.",
      "reasonLabel": "காரணம்",
      "reasonPlaceholder": "எ.கா. தனிமைப்படுத்தல் தேவை, ICU இலிருந்து கீழ்நிலை, அதிக கண்காணிப்பு படுக்கை",
      "actions": {
        "transfer": "மாற்று"
      },
      "toasts": {
        "success": "சந்திப்பு மாற்றப்பட்டது",
        "error": "சந்திப்பை மாற்ற முடியவில்லை"
      }
    },
    "assignAttendingDialog": {
      "title": "பொறுப்பு மருத்துவர் நியமனம்",
      "description": "இந்த வருகைக்குப் பொறுப்பான மருத்துவரை அமைக்கவும்.",
      "providerLabel": "பொறுப்பு மருத்துவர்",
      "loadingProviders": "மருத்துவர்கள் ஏற்றப்படுகிறார்கள்…",
      "selectProvider": "மருத்துவரைத் தேர்ந்தெடுக்கவும்",
      "emptyState": "இந்த வசதியில் செயலில் உள்ள மருத்துவர்கள் இல்லை.",
      "actions": {
        "assign": "நியமிக்கவும்"
      },
      "toasts": {
        "success": "பொறுப்பு மருத்துவர் நியமிக்கப்பட்டார்",
        "error": "பொறுப்பு மருத்துவரை நியமிக்க முடியவில்லை"
      }
    },
    "bedBoard": {
      "bedStatus": {
        "available": "கிடைக்கிறது",
        "occupied": "பயன்பாட்டில்",
        "reserved": "ஒதுக்கப்பட்டது",
        "cleaning": "சுத்தம் செய்யப்படுகிறது",
        "closed": "மூடப்பட்டது",
        "isolated": "தனிமைப்படுத்தப்பட்டது",
        "contaminated": "மாசுபட்டது"
      },
      "acuityLegendLabel": "ESI கடுமை:",
      "empty": "எந்த அலகுகளும் கட்டமைக்கப்படவில்லை",
      "summary": {
        "available_one": "{{count}} கிடைக்கிறது",
        "available_other": "{{count}} கிடைக்கிறது",
        "occupied_one": "{{count}} பயன்பாட்டில்",
        "occupied_other": "{{count}} பயன்பாட்டில்",
        "reserved_one": "{{count}} ஒதுக்கப்பட்டது",
        "reserved_other": "{{count}} ஒதுக்கப்பட்டது",
        "cleaning_one": "{{count}} சுத்தம் செய்யப்படுகிறது",
        "cleaning_other": "{{count}} சுத்தம் செய்யப்படுகிறது",
        "closed_one": "{{count}} மூடப்பட்டது",
        "closed_other": "{{count}} மூடப்பட்டது",
        "isolated_one": "{{count}} தனிமைப்படுத்தப்பட்டது",
        "isolated_other": "{{count}} தனிமைப்படுத்தப்பட்டது",
        "contaminated_one": "{{count}} மாசுபட்டது",
        "contaminated_other": "{{count}} மாசுபட்டது"
      }
    },
    "protocolPanel": {
      "title": "நெறிமுறை பதிவு",
      "enroll": "பதிவு செய்",
      "availableProtocols": "கிடைக்கும் நெறிமுறைகள்",
      "loadingProtocols": "நெறிமுறைகள் ஏற்றப்படுகின்றன...",
      "noProtocols": "நெறிமுறைகள் எதுவும் இல்லை",
      "stepBadge": "படி {{current}}/{{total}}",
      "loadingEnrollments": "பதிவுகள் ஏற்றப்படுகின்றன...",
      "noEnrollments": "செயலில் உள்ள நெறிமுறை பதிவுகள் இல்லை",
      "completeStep": "படியை முடி",
      "toasts": {
        "enrollSuccess": "நெறிமுறையில் பதிவு செய்யப்பட்டது",
        "enrollError": "நெறிமுறையில் பதிவு செய்ய முடியவில்லை",
        "advanceSuccess": "படி முடிந்தது",
        "advanceError": "படியை முன்னேற்ற முடியவில்லை"
      }
    }
  }
}
